import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";
import logo from "../assets/images/logo-fix.png";

const COLS = [
  {
    title: "Produk",
    links: [
      { to: "/schools", label: "Jelajahi Sekolah" },
      { to: "/match", label: "AI School Match" },
      { to: "/compare", label: "Bandingkan" },
    ],
  },
  {
    title: "Perusahaan",
    links: [
      { to: "/tentang", label: "Tentang" },
      { to: "/tentang", label: "Kontak" },
      { to: "/tentang", label: "Karier" },
    ],
  },
  {
    title: "Bantuan",
    links: [
      { to: "/tentang", label: "Pusat Bantuan" },
      { to: "/tentang", label: "Kebijakan Privasi" },
      { to: "/tentang", label: "Syarat & Ketentuan" },
      {
        href: "https://app.emergent.sh/showcase/building-indonesia/d761c7db-67e8-4d11-9ff2-e0580b551416",
        label: "Beri Dukungan",
      },
    ],
  },
];

export default function Footer() {
  const { pathname } = useLocation();
  const footerSpacing = pathname === "/signup" ? "mt-0" : "mt-20";

  return (
    <footer className={`bg-ink text-warm print:hidden ${footerSpacing}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img src={logo} alt="MySchoolMate Logo" className="h-8 w-auto brightness-0 invert" />
            </Link>
            <p className="text-warm/70 max-w-xs leading-relaxed">
              Bantu keluarga Indonesia menemukan dan membandingkan sekolah yang paling cocok untuk
              anak.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-bold mb-3">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((l, i) => (
                  <li key={i}>
                    {l.href ? (
                      <a
                        href={l.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-warm/70 hover:text-mint transition-colors text-sm"
                        data-testid="footer-support"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="text-warm/70 hover:text-mint transition-colors text-sm">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-warm/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-warm/60">
          <div className="flex flex-col gap-1">
            <p>© 2026 MySchoolMate.</p>
          </div>
          <p>
            Dibuat dengan <Heart className="inline text-coral fill-coral mx-1" size={16} /> untuk keluarga Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
}
